<template>
    <el-popover :placement="placement"
                :trigger="trigger">
        <!-- Members -->
        <div class="max-h-16 space-y-0.5 overflow-auto with-custom-scrollbar-dark">
            <trashed-members-item v-for="member in sortedMembers"
                                  :key="member.id"
                                  :member="member" />
        </div>

        <!-- Trigger button -->
        <el-button 
            slot="reference"
            type="text">
            {{ label }}
        </el-button>
    </el-popover>
</template>

<script>
import { sortAsDate } from '@/utils/immutable'

import TrashedMembersItem from '@/components/popovers/TrashedMembersItem'

export default {
  name: 'TrashedMembers',

  components: {
    TrashedMembersItem
  },
  
  props: {
    members: { type: Array, default: () => [] },
    placement: { type: String, default: 'bottom' },
    trigger: { type: String, default: 'click' },
    label: { type: String, default: 'Предыдущие участники' }
  },

  computed: {
    sortedMembers() {
      return this.members.toSorted(sortAsDate(x => new Date(x.deleted_at), 'desc'))
    }
  } 
}

</script>